import { FrontendRegistration } from "@timeedit/registration-schemas";
import { UnsafeRecord } from "@timeedit/registration-shared";
import { createRef, RefObject } from "react";

export function makeActivityRefs(
  registration: FrontendRegistration
): UnsafeRecord<string, RefObject<HTMLDivElement>> {
  return Object.values(registration.courses)
    .flatMap((course) => course?.children ?? [])
    .reduce((acc: UnsafeRecord<string, RefObject<HTMLDivElement>>, cur) => {
      acc[cur] = createRef<HTMLDivElement>();
      return acc;
    }, {});
}
